import React, { useState } from 'react';
import { Button, Panel, Stack, Tag } from 'rsuite';
import { EnergyHub, formatHkd } from '@/models/energy-hub.model';
import { EnergyHubCreditAction } from '@/services/energy-hub.service';
import { jsDateToZone } from '@/utils/date-time';
import CreditDrawer from './credit-drawer';

interface Props {
  hub: EnergyHub;
  onChanged: () => void;
}

const Figure: React.FC<{ label: string; value: number; color?: string }> = ({ label, value, color }) => (
  <div style={{ minWidth: 120 }}>
    <div style={{ color: '#888', fontSize: 12 }}>{label}</div>
    <div style={{ fontSize: 22, fontWeight: 600, color }}>{formatHkd(value)}</div>
  </div>
);

const EnergyHubCreditPanel: React.FC<Props> = ({ hub, onChanged }) => {
  const [action, setAction] = useState<EnergyHubCreditAction | undefined>(undefined);
  const c = hub.credit;
  const freeNow = !!hub.freeUntil && hub.freeUntil.getTime() > Date.now();

  return (
    <Panel bordered style={{ margin: '16px 0' }}>
      <Stack justifyContent="space-between" wrap spacing={16}>
        <Stack spacing={28} wrap>
          <Figure label="Credit balance" value={c.balance} color={c.balance < 0 ? '#e55' : '#2db85d'} />
          <Figure label="Topped up" value={c.totalTopUp} />
          <Figure label="Fees charged" value={c.totalFees} />
          <Figure label="Fees waived" value={c.totalWaived} />
          <Figure label="Refunded" value={c.totalRefunded} />
          <Figure label="Adjusted" value={c.totalAdjusted} />
        </Stack>
        <Stack spacing={6} wrap>
          {freeNow && <Tag color="cyan">Free until {jsDateToZone(hub.freeUntil)}</Tag>}
          <Button appearance="primary" onClick={() => setAction('TopUp')}>Top up</Button>
          <Button appearance="ghost" onClick={() => setAction('Refund')}>Refund</Button>
          <Button appearance="ghost" onClick={() => setAction('Adjust')}>Adjust</Button>
        </Stack>
      </Stack>
      <CreditDrawer
        open={!!action}
        action={action ?? 'TopUp'}
        energyHubId={hub.id}
        balance={c.balance}
        onClose={() => setAction(undefined)}
        onSubmitted={() => { setAction(undefined); onChanged(); }}
      />
    </Panel>
  );
};

export default EnergyHubCreditPanel;
